<template>
    <pre class="overflow-auto text-xs font-light p-4 border rounded bg-gray-800 text-gray-200"><slot /></pre>
</template>

<script>
export default {
    name: 'CodeSnippet'
}
</script>
